import React from "react";
import {
	HeroSection,
	MVTSection,
} from "../../components/sections/mission-vision-tenet";

export default function MissionVision(props) {
	return (
		<>
			<HeroSection />

			<MVTSection />
		</>
	);
}
